/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IncomeStatsSchema } from '../models/IncomeStatsSchema';
import type { MrecordPeriodStatsSchema } from '../models/MrecordPeriodStatsSchema';
import type { NewPatientsStatsSchema } from '../models/NewPatientsStatsSchema';
import type { PhysiosVisitsStatsSchema } from '../models/PhysiosVisitsStatsSchema';
import type { ReceiptFilterPaymentStatus } from '../models/ReceiptFilterPaymentStatus';
import type { ReceiptInvoiceType } from '../models/ReceiptInvoiceType';
import type { ReceiptPaymentType } from '../models/ReceiptPaymentType';
import type { ReceiptsFinancialStatsSchema } from '../models/ReceiptsFinancialStatsSchema';
import type { ServiceCategoriesStatsSchema } from '../models/ServiceCategoriesStatsSchema';
import type { SmsPeriodStatsSchema } from '../models/SmsPeriodStatsSchema';
import type { UserIncomeStatsSchema } from '../models/UserIncomeStatsSchema';
import type { VisitsFinancialStatsSchema } from '../models/VisitsFinancialStatsSchema';
import type { VisitStatsSchema } from '../models/VisitStatsSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StatsApi {
    /**
     * Get Income Per Physio Stats
     * Get overview of income from patients visits in given year grouped by given time period. <br>Required Permission: list_income_stats
     * @returns UserIncomeStatsSchema OK
     * @throws ApiError
     */
    public static statsGetIncomePerPhysioStatsGet({
        year,
    }: {
        year: number,
    }): CancelablePromise<Record<string, UserIncomeStatsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/income/{year}/users/',
            path: {
                'year': year,
            },
        });
    }
    /**
     * Get Income Stats
     * Get overview of income from patients visits in given year grouped by given time period. <br>Required Permission: list_income_stats
     * @returns IncomeStatsSchema OK
     * @throws ApiError
     */
    public static statsGetIncomeStatsGet({
        year,
        period,
    }: {
        year: number,
        period?: 'MONTH' | 'QUARTER' | 'YEAR',
    }): CancelablePromise<IncomeStatsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/income/{year}/',
            path: {
                'year': year,
            },
            query: {
                'period': period,
            },
        });
    }
    /**
     * Get Mrecords Usage Stats
     * Get overview of M-record usage in given time period. <br>Required Permission: list_mrecords_usage_stats
     * @returns MrecordPeriodStatsSchema OK
     * @throws ApiError
     */
    public static statsGetMrecordsUsageStatsGet({
        startDate,
        endDate,
    }: {
        startDate?: (string | null),
        endDate?: (string | null),
    }): CancelablePromise<Array<MrecordPeriodStatsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/mrecords-usage/',
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
    /**
     * Get New Patients Stats
     * Get count of new patients grouped by sex and given time period. <br>Required Permission: list_new_patients_stats
     * @returns NewPatientsStatsSchema OK
     * @throws ApiError
     */
    public static statsGetNewPatientsStatsGet({
        year,
        period,
    }: {
        year: number,
        period?: 'MONTH' | 'QUARTER' | 'YEAR',
    }): CancelablePromise<NewPatientsStatsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/new-patients/{year}/',
            path: {
                'year': year,
            },
            query: {
                'period': period,
            },
        });
    }
    /**
     * Get Physios Visits Stats
     * Get share of visits per user for given company. <br>Required Permission: list_physio_visit_stats
     * @returns PhysiosVisitsStatsSchema OK
     * @throws ApiError
     */
    public static statsGetPhysiosVisitsStatsGet({
        dateFrom,
        dateTo,
        patientNotCome = false,
    }: {
        dateFrom?: (string | null),
        dateTo?: (string | null),
        patientNotCome?: boolean,
    }): CancelablePromise<Array<PhysiosVisitsStatsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/physios-visits/',
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
                'patient_not_come': patientNotCome,
            },
        });
    }
    /**
     * Get Receipts Financial Stats
     * Get simple financial stats for receipts <br>Required Permission: list_visit_stats
     * @returns ReceiptsFinancialStatsSchema OK
     * @throws ApiError
     */
    public static statsGetReceiptsFinancialStatsGet({
        cancelled,
        createdFrom,
        createdTo,
        searching,
        userId,
        paymentStatus,
        paymentTypes,
        invoiceTypes,
        locationId,
    }: {
        /**
         * Use payment_status instead
         * @deprecated
         */
        cancelled: boolean,
        createdFrom?: (string | null),
        createdTo?: (string | null),
        searching?: (string | null),
        userId?: (string | null),
        paymentStatus?: (ReceiptFilterPaymentStatus | null),
        paymentTypes?: (Array<ReceiptPaymentType> | null),
        invoiceTypes?: (Array<ReceiptInvoiceType> | null),
        locationId?: (string | null),
    }): CancelablePromise<ReceiptsFinancialStatsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/receipts-financial-stats/',
            query: {
                'created_from': createdFrom,
                'created_to': createdTo,
                'searching': searching,
                'user_id': userId,
                'cancelled': cancelled,
                'payment_status': paymentStatus,
                'payment_types': paymentTypes,
                'invoice_types': invoiceTypes,
                'location_id': locationId,
            },
        });
    }
    /**
     * Get Service Categories Patients Stats
     * Get count of unique patients visits in given service category in given year.If new_patient=True, count of unique patients that had their first visitin given service category will be returned.<br>Require Permission: list_service_category_patient_stats
     * @returns ServiceCategoriesStatsSchema OK
     * @throws ApiError
     */
    public static statsGetServiceCategoriesPatientsStatsGet({
        year,
        newPatients = false,
    }: {
        year: number,
        newPatients?: boolean,
    }): CancelablePromise<Array<ServiceCategoriesStatsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/categories/patients/{year}/',
            path: {
                'year': year,
            },
            query: {
                'new_patients': newPatients,
            },
        });
    }
    /**
     * Get Service Categories Stats
     * Get count of visits per service category in given year. <br>Required Permission: list_service_category_stats
     * @returns ServiceCategoriesStatsSchema OK
     * @throws ApiError
     */
    public static statsGetServiceCategoriesStatsGet({
        year,
    }: {
        year: number,
    }): CancelablePromise<Array<ServiceCategoriesStatsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/categories/{year}/',
            path: {
                'year': year,
            },
        });
    }
    /**
     * Get Sms Usage Stats
     * Get overview of sms usage in given time period. <br>Required Permission: list_sms_usage_stats
     * @returns SmsPeriodStatsSchema OK
     * @throws ApiError
     */
    public static statsGetSmsUsageStatsGet({
        startDate,
        endDate,
    }: {
        startDate?: (string | null),
        endDate?: (string | null),
    }): CancelablePromise<Array<SmsPeriodStatsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/sms-usage/',
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
    /**
     * Get Visit Stats
     * Get count of visits in given year grouped by given period and patients sex. <br>Required Permission: list_visit_stats
     * @returns VisitStatsSchema OK
     * @throws ApiError
     */
    public static statsGetVisitStatsGet({
        year,
        period,
    }: {
        year: number,
        period?: 'MONTH' | 'QUARTER' | 'YEAR',
    }): CancelablePromise<VisitStatsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/visits/{year}/',
            path: {
                'year': year,
            },
            query: {
                'period': period,
            },
        });
    }
    /**
     * Get Visits Financial Stats
     * Get simple financial stats for visits <br>Required Permission: list_visit_stats
     * @returns VisitsFinancialStatsSchema OK
     * @throws ApiError
     */
    public static statsGetVisitsFinancialStatsGet({
        createdFrom,
        createdTo,
        searching,
        userId,
        paid,
    }: {
        createdFrom?: (string | null),
        createdTo?: (string | null),
        searching?: (string | null),
        userId?: (string | null),
        paid?: (boolean | null),
    }): CancelablePromise<VisitsFinancialStatsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stats/visits-financial-stats/',
            query: {
                'created_from': createdFrom,
                'created_to': createdTo,
                'searching': searching,
                'user_id': userId,
                'paid': paid,
            },
        });
    }
}
